import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface BankAccountFieldsProps {
  accountHolder: string;
  accountNumber: string;
  routingNumber: string;
  accountType: string;
  onAccountHolderChange: (value: string) => void;
  onAccountNumberChange: (value: string) => void;
  onRoutingNumberChange: (value: string) => void;
  onAccountTypeChange: (value: string) => void;
}

export function BankAccountFields({
  accountHolder,
  accountNumber,
  routingNumber,
  accountType,
  onAccountHolderChange,
  onAccountNumberChange,
  onRoutingNumberChange,
  onAccountTypeChange,
}: BankAccountFieldsProps) {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="accountHolder">Account Holder Name</Label>
        <Input
          id="accountHolder"
          placeholder="Enter account holder name"
          value={accountHolder}
          onChange={(e) => onAccountHolderChange(e.target.value)}
          required
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="accountNumber">Account Number</Label>
        <Input
          id="accountNumber"
          placeholder="Enter your bank account number"
          value={accountNumber}
          onChange={(e) => onAccountNumberChange(e.target.value)}
          required
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="routingNumber">Routing Number</Label>
        <Input
          id="routingNumber"
          placeholder="Enter your bank routing number"
          value={routingNumber}
          onChange={(e) => onRoutingNumberChange(e.target.value)}
          required
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="accountType">Account Type</Label>
        <Select value={accountType} onValueChange={onAccountTypeChange}>
          <SelectTrigger>
            <SelectValue placeholder="Select account type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="individual">Individual</SelectItem>
            <SelectItem value="business">Business</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </>
  );
}